import priorityNav from '../priority-nav.js'

export default function header ($header, { $refs, sticky }) {
  priorityNav.init({
    mainNavWrapper: '.js-nav',
    mainNav: '.js-nav > ul',
    navDropdownLabel: `More <span class="w-20 h-20 rounded-full border border-yellow ml-10 flex items-center justify-center text-yellow pointer-events-none is-open:rotate-180">
      <svg width="10" height="7" viewBox="0 0 10 7">
        <polyline fill="none" stroke="currentColor" stroke-width="1.5" points="7 5 13 5 13 11" transform="rotate(135 8.95 3.464)"></polyline>
      </svg>
    </span>`,
    calculateWidth () {
      let containerPadding = window.innerWidth >= 1280 ? 100 : 50
      let navPadding = window.innerWidth >= 1024 ? 80 : 40
      return (
        $header.offsetWidth -
        containerPadding -
        navPadding -
        $refs.measure.reduce((acc, curr) => {
          return acc + curr.offsetWidth
        }, 0)
      )
    }
  })

  let lastKnownScrollPosition = 0
  let ticking = false
  let isCompressed = false
  let isScrolled = false
  let headerTop = null
  let isFixed = false
  let $spacer = null

  function showCompressed () {
    isCompressed = true
    $header.classList.add('is-compressed')
  }

  function hideCompressed () {
    isCompressed = false
    $header.classList.remove('is-compressed')
  }

  function updateHeader (scrollPos) {
    if (!isScrolled && scrollPos > 0) {
      isScrolled = true
      $header.classList.add('is-scrolled')
    } else if (isScrolled && scrollPos <= 0) {
      isScrolled = false
      $header.classList.remove('is-scrolled')
    }

    if (!isCompressed && scrollPos > window.innerHeight) {
      showCompressed()
    } else if (isCompressed && scrollPos <= window.innerHeight) {
      hideCompressed()
    }

    if (headerTop !== null && window.innerWidth < 768) {
      if (!isFixed && scrollPos >= headerTop) {
        isFixed = true
        $spacer = document.createElement('div')
        $spacer.style.height = `${$header.offsetHeight}px`
        $header.parentNode.insertBefore($spacer, $header)
        $header.style.position = 'fixed'
      } else if (isFixed && scrollPos < headerTop) {
        isFixed = false
        $spacer.parentNode.removeChild($spacer)
        $header.style.position = 'relative'
      }
    }
  }

  function onScroll (e) {
    lastKnownScrollPosition = window.pageYOffset

    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateHeader(lastKnownScrollPosition)
        ticking = false
      })

      ticking = true
    }
  }

  function onResize () {
    if (isFixed && window.innerWidth >= 768) {
      isFixed = false
      $spacer.parentNode.removeChild($spacer)
      $header.style.position = 'relative'
    } else if (sticky && !isFixed && window.innerWidth < 768) {
      headerTop =
        $header.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top
    }
  }
  onResize()

  window.addEventListener('scroll', onScroll)
  window.addEventListener('resize', onResize)

  return () => {
    window.removeEventListener('scroll', onScroll)
    window.removeEventListener('resize', onResize)
  }
}



// WEBPACK FOOTER //
// ./src/js/components/header.js